import React, { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import { MenuItem, Classes } from "@blueprintjs/core";
import GeneralSelectList from "components/GeneralSelectList";
import "./InRoomAnnouncement.scss";

const InRoomAnnouncementWebController = ({
  languageList,
  sendAnnouncement,
  announcementList,
  languageSelected,
  announcementSelected,
  userName,
  isPlaying,
  isAnnouncementPlaying,
  hideAnnouncementUI

}) => {
  const { t } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState({
    ID: "",
    value: "SELECT_LANGUAGE",
  });
  const [selectedAnnouncemnt, setSelectedAnnouncment] = useState({
    ID: "",
    value: "SELECT_ANNOUNCEMENT",
  });

  const renderLanguageItem = (item, { index, handleClick }) => {
    return (
      <MenuItem
        className={
          item.ID === selectedLanguage.ID
            ? `${item.ID} ${Classes.ACTIVE}}`
            : item.ID
        }
        onClick={handleClick}
        text={item.value}
        key={item.ID}
      />
    );
  };

  const renderAnnouncementOptionItem = (item, { index, handleClick }) => {
    return (
      <MenuItem
        className={
          item.ID === selectedAnnouncemnt.ID
            ? `${item.ID} ${Classes.ACTIVE}}`
            : item.ID
        }
        onClick={handleClick}
        text={t(item.value)}
        key={item.ID}
      />
    );
  };

  const languageItemSelect = (item) => {
    languageSelected(item);
    setSelectedLanguage(item);
  };
  const announcementItemSelect = (item) => {
    announcementSelected(item);
    setSelectedAnnouncment(item);
  };

  const renderInRoomAnnouncementTabContent = () => {
    return renderInRoomAnnouncementContentUI();
  };

  const sendAnnouncementToService = () => {
    sendAnnouncement(selectedLanguage, selectedAnnouncemnt);
  };

  const renderInRoomAnnouncementContentUI = () => {
    return (
      <React.Fragment>
        {announcementList && announcementList?.length > 0 && (
          <div className="announcement-list-container">
            <div className="announcement-list-title">{t("ANNOUNCEMENTS")}</div>
            <GeneralSelectList
              items={announcementList}
              className="announcement-list"
              customRenderItem={renderAnnouncementOptionItem}
              onItemSelect={announcementItemSelect}
              selectedItemName={t(selectedAnnouncemnt.value)}
              portalClassName="announcement-selection-list"
            />
          </div>
        )}
        {languageList && languageList?.length > 0 && (
          <div className="language-list-container">
            <div className="language-list-title">{t("LANGUAGE")}</div>
            <GeneralSelectList
              items={languageList}
              className="language-list"
              customRenderItem={renderLanguageItem}
              onItemSelect={languageItemSelect}
              selectedItemName={t(selectedLanguage.value)}
              portalClassName="language-selection-list"
            />
          </div>
        )}
        <div className="send-button-container"><button
            className="announcement-send-button cancel-button"
            onClick={hideAnnouncementUI}
          >
            {t("CANCEL")}
          </button>

          <button
            disabled={
              selectedLanguage.ID === "" || selectedAnnouncemnt.ID === ""
            }
            className="announcement-send-button"
            onClick={sendAnnouncementToService}
          >
            {t("SEND")}
          </button>
          
        </div>
      </React.Fragment>
    );
  };

  return (
    <div className="in-room-announcment-container">
      <div className="in-room-announcment-popup-title">
        {t("IN_ROOM_ANNOUNCEMENT_TITLE")}
      </div>
      {isAnnouncementPlaying ? (
        <div className="announcement-playing-info">
          {t("ANNOUNCEMENT_PLAYING_MESSAGE")}
        </div>
      ) : (
        renderInRoomAnnouncementTabContent()
      )}
    </div>
  );
};

export default memo(InRoomAnnouncementWebController);
